module.exports = __webpack_public_path__ + "static/media/icon-event-entry.5ed10e2c.png";